const schema = () => ({
  type: 'object',
  title: '',
  required: [],
  properties: {
    // days: {
    //   type: 'object',
    //   title: 'روزهای هفته',
    //   properties: {
    //     saturday: {
    //       title: 'شنبه',
    //       type: 'object',
    //       properties: {
    //         am: {
    //           title: 'صبح ها',
    //           type: 'object',
    //           properties: {
    //             from: {
    //               type: 'number',
    //               title: 'از ساعت',
    //             },
    //             to: {
    //               type: 'number',
    //               title: 'تا ساعت',
    //             },
    //           },
    //         },
    //         pm: {
    //           title: 'عصر ها',
    //           type: 'object',
    //           properties: {
    //             from: {
    //               type: 'number',
    //               title: 'از ساعت',
    //             },
    //             to: {
    //               type: 'number',
    //               title: 'تا ساعت',
    //             },
    //           },
    //         },
    //       },
    //     },
    //     sunday: {
    //       title: 'یکشنبه',
    //       type: 'object',
    //       properties: {
    //         am: {
    //           title: 'صبح ها',
    //           type: 'object',
    //           properties: {
    //             from: {
    //               type: 'number',
    //               title: 'از ساعت',
    //             },
    //             to: {
    //               type: 'number',
    //               title: 'تا ساعت',
    //             },
    //           },
    //         },
    //         pm: {
    //           title: 'عصر ها',
    //           type: 'object',
    //           properties: {
    //             from: {
    //               type: 'number',
    //               title: 'از ساعت',
    //             },
    //             to: {
    //               type: 'number',
    //               title: 'تا ساعت',
    //             },
    //           },
    //         },
    //       },
    //     },
    //     monday: {
    //       title: 'دوشنبه',
    //       type: 'object',
    //       properties: {
    //         am: {
    //           title: 'صبح ها',
    //           type: 'object',
    //           properties: {
    //             from: {
    //               type: 'number',
    //               title: 'از ساعت',
    //             },
    //             to: {
    //               type: 'number',
    //               title: 'تا ساعت',
    //             },
    //           },
    //         },
    //         pm: {
    //           title: 'عصر ها',
    //           type: 'object',
    //           properties: {
    //             from: {
    //               type: 'number',
    //               title: 'از ساعت',
    //             },
    //             to: {
    //               type: 'number',
    //               title: 'تا ساعت',
    //             },
    //           },
    //         },
    //       },
    //     },
    //     tuesday: {
    //       title: 'سه شنبه',
    //       type: 'object',
    //       properties: {
    //         am: {
    //           title: 'صبح ها',
    //           type: 'object',
    //           properties: {
    //             from: {
    //               type: 'number',
    //               title: 'از ساعت',
    //             },
    //             to: {
    //               type: 'number',
    //               title: 'تا ساعت',
    //             },
    //           },
    //         },
    //         pm: {
    //           title: 'عصر ها',
    //           type: 'object',
    //           properties: {
    //             from: {
    //               type: 'number',
    //               title: 'از ساعت',
    //             },
    //             to: {
    //               type: 'number',
    //               title: 'تا ساعت',
    //             },
    //           },
    //         },
    //       },
    //     },
    //     wednesday: {
    //       title: 'چهارشنبه',
    //       type: 'object',
    //       properties: {
    //         am: {
    //           title: 'صبح ها',
    //           type: 'object',
    //           properties: {
    //             from: {
    //               type: 'number',
    //               title: 'از ساعت',
    //             },
    //             to: {
    //               type: 'number',
    //               title: 'تا ساعت',
    //             },
    //           },
    //         },
    //         pm: {
    //           title: 'عصر ها',
    //           type: 'object',
    //           properties: {
    //             from: {
    //               type: 'number',
    //               title: 'از ساعت',
    //             },
    //             to: {
    //               type: 'number',
    //               title: 'تا ساعت',
    //             },
    //           },
    //         },
    //       },
    //     },
    //     thursday: {
    //       title: 'پنجشنبه',
    //       type: 'object',
    //       properties: {
    //         am: {
    //           title: 'صبح ها',
    //           type: 'object',
    //           properties: {
    //             from: {
    //               type: 'number',
    //               title: 'از ساعت',
    //             },
    //             to: {
    //               type: 'number',
    //               title: 'تا ساعت',
    //             },
    //           },
    //         },
    //         pm: {
    //           title: 'عصر ها',
    //           type: 'object',
    //           properties: {
    //             from: {
    //               type: 'number',
    //               title: 'از ساعت',
    //             },
    //             to: {
    //               type: 'number',
    //               title: 'تا ساعت',
    //             },
    //           },
    //         },
    //       },
    //     },
    //     friday: {
    //       title: 'جمعه',
    //       type: 'object',
    //       properties: {
    //         am: {
    //           title: 'صبح ها',
    //           type: 'object',
    //           properties: {
    //             from: {
    //               type: 'number',
    //               title: 'از ساعت',
    //             },
    //             to: {
    //               type: 'number',
    //               title: 'تا ساعت',
    //             },
    //           },
    //         },
    //         pm: {
    //           title: 'عصر ها',
    //           type: 'object',
    //           properties: {
    //             from: {
    //               type: 'number',
    //               title: 'از ساعت',
    //             },
    //             to: {
    //               type: 'number',
    //               title: 'تا ساعت',
    //             },
    //           },
    //         },
    //       },
    //     },
    //   },
    // },
    all: {
      type: 'object',
      title: '',
      properties: {
        am: {
          title: 'صبح ها',
          type: 'object',
          properties: {
            from: {
              type: 'number',
              title: 'از ساعت',
            },
            to: {
              type: 'number',
              title: 'تا ساعت',
            },
          },
        },
        pm: {
          title: 'عصر ها',
          type: 'object',
          properties: {
            from: {
              type: 'number',
              title: 'از ساعت',
            },
            to: {
              type: 'number',
              title: 'تا ساعت',
            },
          },
        },
      },
    },
  },
});

export default schema;
